import { Tooltip } from '@toggle/design-system';
import {
  ExploreInsightCondition,
  ExploreInsightDirection,
} from '@toggle/toggle';
import React, { memo, ReactElement } from 'react';

import { InsightDetails } from '~/components/insights-group/insight-card/insights-details/InsightDetails';
import { InsightIconsRoot } from '~/views/insights/components/insight-icons-root/InsightIconsRoot';

import tooltipStyles from './InsightsTooltip.module.scss';
import * as S from './InsightsTooltip.styles';

interface InsightsTooltipProps {
  children: ReactElement<Record<string, unknown>>;
  conditions: ExploreInsightCondition[];
  direction: ExploreInsightDirection;
  customSize?: { width: string; height: string };
  isStarred: boolean;
  isCombined?: boolean;
  isMatched?: boolean;
  layout?: 'horizontal' | 'vertical';
  horizon: string;
  median: number;
  name: string;
  stars: number;
  entityTag?: string;
  episodeLabel: string;
}

export const InsightsTooltipComponent = ({
  horizon,
  median,
  name,
  stars,
  conditions,
  direction,
  customSize,
  isStarred,
  isCombined,
  isMatched = true,
  layout,
  children,
  entityTag,
  episodeLabel,
}: InsightsTooltipProps) => {
  const tooltipContent = () => {
    return (
      <S.StyledBubble>
        <InsightIconsRoot
          conditions={conditions}
          direction={direction}
          isStarred={isStarred}
          customSize={customSize}
          isCombined={isCombined}
          isMatched={isMatched}
          layout={layout}
        />
        <InsightDetails
          isTooltip
          median={median}
          horizon={horizon}
          name={name}
          stars={stars}
          direction={direction}
          isNewInsight={isStarred}
          entityTag={entityTag}
          episodeLabel={episodeLabel}
        />
      </S.StyledBubble>
    );
  };

  return (
    <Tooltip
      className={tooltipStyles.tooltip}
      placement="top-start"
      label={tooltipContent()}
      inPortal
    >
      {children}
    </Tooltip>
  );
};

export const InsightsTooltip = memo(InsightsTooltipComponent);
